import { ChevronRight, ChevronUp } from "lucide-react";

type ChevronPosition = "90" | "180";

export const CHEVRON_POSITION: Record<ChevronPosition, typeof ChevronRight> = {
  "90": ChevronRight,
  "180": ChevronUp,
} as const;
